import { type ReactElement } from 'react';
import BatteryMonitoring from '@/features/BatteryMonitoring';

const AppPage = (): ReactElement => <BatteryMonitoring />;

export default AppPage;
